import { render, staticRenderFns } from "./Boarding.vue?vue&type=template&id=e5743194&scoped=true&"
import script from "./Boarding.vue?vue&type=script&lang=js&"
export * from "./Boarding.vue?vue&type=script&lang=js&"
import style0 from "./Boarding.vue?vue&type=style&index=0&id=e5743194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5743194",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Stage1: require('/home/bitrix/frontend/components/boarding/Stage1.vue').default,Stage2: require('/home/bitrix/frontend/components/boarding/Stage2.vue').default,Stage3: require('/home/bitrix/frontend/components/boarding/Stage3.vue').default,Stage4: require('/home/bitrix/frontend/components/boarding/Stage4.vue').default,MtArrowLink: require('/home/bitrix/frontend/components/other/MtArrowLink.vue').default})
